import { ContentSwitcher } from '@xing-com/content-switcher';
import { ProductType } from '@xing-com/crate-common-graphql-types';
import { useLocation } from '@xing-com/crate-core-router';

export type NavigationProps = {
  product: ProductType;
};

export const Navigation: React.FC<NavigationProps> = ({ product }) => {
  const { search } = useLocation();
  const contentSwitcherData = [
    {
      copy: 'Premium',
      href: product !== ProductType.Premium ? `/purchase/premium${search}` : '',
    },
    {
      copy: 'ProJobs',
      href: product !== ProductType.Projobs ? `/purchase/projobs${search}` : '',
    },
  ];

  return (
    <ContentSwitcher
      data-testid="navigation"
      size="small"
      variant="filled"
      activeItemIndex={product === ProductType.Premium ? 0 : 1}
      data={contentSwitcherData}
    />
  );
};
